import React from "react";
import { useForm } from "react-hook-form";
import { useState } from "react";
import { useEffect } from "react";
import { notify } from "../../Datas/Functions/toast";
import { useAuthContext } from "../../Contexts/AuthContext";

const ProfileRight = ({ user }) => {
  const { user: myProfile, setUser } = useAuthContext();
  const [isEdit, setIsEdit] = useState(true);
  const [imgInputChange, setImginputChange] = useState(null);
  const [loggedUser, setLoggedUser] = useState(null);
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();
  useEffect(() => {
    if (loggedUser)
      Object.keys(loggedUser).forEach((key) => {
        setValue(key, loggedUser[key]);
      });
  }, [loggedUser]);
  useEffect(() => {
    setLoggedUser(user);
  }, [user]);
  const onSubmit = (data) => {
    console.log(data);
  };
  const handleImgChange = async (e) => {
    const file = e.target.files[0];

    // Create a new FormData object
    const formData = new FormData();
    formData.append("image", file);

    // Make a POST request to the ImgBB API
    const response = await fetch(
      "https://api.imgbb.com/1/upload?key=YOUR_API_KEY",
      {
        method: "POST",
        body: formData,
      }
    );

    const data = await response.json();

    // Get the image URL from the API response
    const { display_url } = data.data;

    // Set the image URL in the state
    // setImageURL(display_url);
  };
  return (
    <div className="lg:col-span-2 col-span-1 dark:dark-bg-front bg-front p-5 rounded-lg box">
      <h2 className="text-2xl font-bold my-2">Profile Information</h2>
      <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
        <div className="my-5">
          <label className="capitalize font-bold my-1" htmlFor="name">
            Name :
          </label>
          <div className="flex items-center text-sm ">
            <span className="inline-block w-6 h-6 mr-2">
              <i className="fa fa-user" aria-hidden="true"></i>
            </span>
            <input
              type="text"
              id="name"
              className={`border rounded w-full py-2 px-4 dark:dark-bg-front bg-front outline-none border-1 ${
                isEdit ? "border-transparent " : "border-orange-300"
              }`}
              disabled={isEdit}
              defaultValue={loggedUser?.name}
              placeholder="Enter your Name"
              {...register("name", {
                required: "Please Enter your Name",
              })}
            />
          </div>
          {errors.name && (
            <p className="text-red-500 text-xs mt-1">{errors.name.message}</p>
          )}
        </div>
        <div className="my-5">
          <label className="capitalize font-bold my-1" htmlFor="email">
            email :
          </label>
          <div
            className="flex items-center text-sm"
            onClick={() => {
              if (!isEdit) {
                notify("Warning", "You can not edit your email", "error");
              }
            }}
          >
            <span className="inline-block w-6 h-6 mr-2">
              <i className="fa fa-envelope" aria-hidden="true"></i>
            </span>
            <input
              type="email"
              id="email"
              className={`border rounded w-full py-2 px-4 dark:dark-bg-front bg-front outline-none border-1 ${
                isEdit ? "border-transparent " : "border-orange-300"
              }`}
              disabled={true}
              defaultValue={loggedUser?.email}
              placeholder="Enter your email"
              {...register("email", {
                required: "Please Enter your Email",
              })}
            />
          </div>
          {errors.email && (
            <p className="text-red-500 text-xs mt-1">{errors.email.message}</p>
          )}
        </div>
        <div className="my-5">
          <label className="capitalize font-bold my-1" htmlFor="img">
            Change Photo :
          </label>
          <div className="flex items-center   text-sm">
            <span className="inline-block w-6 h-6 mr-2">
              <i className="fa fa-camera" aria-hidden="true"></i>
            </span>
            <input
              type="file"
              accept=".png, .jpg, .jpeg"
              id="img"
              disabled={isEdit}
              onChange={(e) => setImginputChange(e.target.files[0])}
              className={`border rounded w-full py-2 px-4 dark:dark-bg-front bg-front outline-none border-1 ${
                isEdit ? "border-transparent " : "border-orange-300"
              }`}
            />
          </div>
          {errors.email && (
            <p className="text-red-500 text-xs mt-1">{errors.email.message}</p>
          )}
          {/* {imgInputChange && <img src={imgInputChange} />} */}
        </div>
        {user.id === myProfile.id && (
          <div className="text-center">
            <button
              type="button"
              onClick={() => setIsEdit((prev) => !prev)}
              className="site-btn mx-2 py-2 px-4 click-effect"
            >
              {isEdit ? (
                <span>
                  <i className="fa fa-edit"></i> Edit Profile
                </span>
              ) : (
                <span>
                  <i className="fa fa-times    "></i> Cancel Edit
                </span>
              )}
            </button>
            {!isEdit && (
              <button
                type="submit"
                className="site-btn mx-2 my-2 py-2 px-4 click-effect"
              >
                <i className="fa fa-save    "></i> Save Profile
              </button>
            )}
          </div>
        )}
      </form>
    </div>
  );
};

export default ProfileRight;
